'use client'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import { Icon } from './icon'

interface FaqItemProps {
  q: string
  a: React.ReactNode
}

/** Item de FAQ em acordeão (conteúdo de SEO abaixo da ferramenta). */
export function FaqItem({ q, a }: FaqItemProps) {
  const [open, setOpen] = useState(false)
  return (
    <div className="border-b border-line">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 py-4 text-left"
      >
        <span className="text-[15px] font-medium leading-snug text-ink">{q}</span>
        <span className={cn('shrink-0 text-ink-mute transition-transform', open && 'rotate-90')}>
          <Icon name="chevron" size={18} />
        </span>
      </button>
      {open && <div className="pb-[18px] text-[14.5px] leading-relaxed text-ink-soft">{a}</div>}
    </div>
  )
}
